// Modül 7 - Dış Görünüm ve İmaj - İnteraktif İçerikler

const cabinCrewContentsM7Interactive = {
  // ==================== ÜNİTE 1: İLK İZLENİM ====================
  'CM-M7-U1-L1': {
    lesson_id: 'CM-M7-U1-L1',
    title: 'Profesyonel Görünüm',
    type: 'interactive',
    duration: 3,
    xp: 20,
    content: {
      title: '👔 İlk 30 Saniye = Tüm İzlenim',
      intro: 'İlk izlenim için ikinci şans yok!',
      facts: [
        { icon: '⏱️', title: '7 Saniye', text: 'İlk izlenim 7 saniyede oluşur' },
        { icon: '👀', title: '%55 Görünüm', text: 'Görünüm en etkili faktör' },
        { icon: '🗣️', title: '%38 Ses', text: 'Ses tonu ve hızı' },
        { icon: '💬', title: '%7 Sözler', text: 'Söylediğin kelimeler' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İlk izlenimde en etkili ne?',
        options: [
          { text: 'Söylediğin', isCorrect: false, feedback: '❌ Sadece %7!' },
          { text: 'Görünümün', isCorrect: true, feedback: '✅ %55 görünüme dayalı!' },
          { text: 'Özgeçmişin', isCorrect: false, feedback: '❌ Henüz okumadılar!' }
        ]
      }
    }
  },

  'CM-M7-U1-L2': {
    lesson_id: 'CM-M7-U1-L2',
    title: 'Beden Dili',
    type: 'interactive',
    duration: 3,
    xp: 20,
    content: {
      title: '🧑‍🤝‍🧑 Giriş Anı Beden Dili',
      intro: 'Kapıdan girdiğin an başlıyor!',
      steps: [
        { level: 1, title: '🚶 YÜRÜYÜŞ', desc: 'Dik ve kendinden emin' },
        { level: 2, title: '🙂 YÜZ', desc: 'Doğal gülümseme' },
        { level: 3, title: '👀 GÖZ', desc: 'Göz teması kur' },
        { level: 4, title: '🤝 SELAM', desc: 'Güçlü el sıkışma' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Odaya girerken?',
        options: [
          { text: 'Hızla gir, otur', isCorrect: false, feedback: '❌ Aceleci görünür!' },
          { text: 'Dik yürü, gülümse, selamla', isCorrect: true, feedback: '✅ Profesyonel giriş!' },
          { text: 'Yere bak, sessiz gir', isCorrect: false, feedback: '❌ Güvensiz görünür!' }
        ]
      }
    }
  },

  'CM-M7-U1-L3': {
    lesson_id: 'CM-M7-U1-L3',
    title: 'Senaryo: İlk İzlenim',
    type: 'scenario',
    duration: 4,
    xp: 30,
    scenario: {
      question: '🚶 SENARYO: Giriş Anı',
      context: 'Mülakat odasına giriyorsun. Masada 3 değerlendirmeci oturuyor. Ne yaparsın?',
      options: [
        { id: 'A', text: 'Hızla otur, başlayalım', isCorrect: false },
        { id: 'B', text: 'Selam ver, gülümse, el sıkış, izin isteyip otur', isCorrect: true },
        { id: 'C', text: 'Sessizce otur, soruları bekle', isCorrect: false },
        { id: 'D', text: 'Herkesle tek tek tanış', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 PROFESYONEL! Selam + Gülümseme + Oturma izni = Mükemmel giriş!',
        wrong: '❌ İlk izlenimi doğru kur!'
      },
      explanation: 'Giriş ritmı: Selam → Gülümse → "Oturabilir miyim?" → Otur → Hazır ol'
    }
  },

  // ==================== ÜNİTE 2: GROOMİNG STANDARTLARI ====================
  'CM-M7-U2-L1': {
    lesson_id: 'CM-M7-U2-L1',
    title: 'Saç ve Makyaj',
    type: 'interactive',
    duration: 3,
    xp: 20,
    content: {
      title: '💇‍♀️ Saç ve Makyaj Standartları',
      intro: 'Havayolu standartlarına uygun görünüm:',
      categories: [
        { icon: '👩', title: 'Kadın Saç', examples: 'Topuz, French twist, düzgün', desc: 'Yüz açık, doğal renk' },
        { icon: '👨', title: 'Erkek Saç', examples: 'Kısa, düzgün, temiz', desc: 'Kulak üstü, yaka altı' },
        { icon: '💄', title: 'Makyaj', examples: 'Doğal, mat, kırmızı ruj', desc: 'Aşırıya kaçma' },
        { icon: '🧝‍♂️', title: 'Traş', examples: 'Temiz traş veya düzgün sakal', desc: 'Bakımlı görünüm' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Kadın aday için ideal saç?',
        options: [
          { text: 'Renkli, serbest', isCorrect: false, feedback: '❌ Havayolu standartı değil!' },
          { text: 'Doğal renk, topuz veya düzgün', isCorrect: true, feedback: '✅ Profesyonel standard!' },
          { text: 'Önemli değil', isCorrect: false, feedback: '❌ Çok önemli!' }
        ]
      }
    }
  },

  'CM-M7-U2-L2': {
    lesson_id: 'CM-M7-U2-L2',
    title: 'Kıyafet Seçimi',
    type: 'interactive',
    duration: 3,
    xp: 20,
    content: {
      title: '👔 Mülakat Kıyafeti',
      intro: 'Doğru kıyafet seçimi:',
      facts: [
        { icon: '👗', title: 'Kadın', text: 'Kalem etek + Bluz + Topuk (5-7cm)' },
        { icon: '👔', title: 'Erkek', text: 'Takım elbise + Kravat + Cilalı ayakkabı' },
        { icon: '🎨', title: 'Renk', text: 'Lacivert, siyah, gri (nötr)' },
        { icon: '✨', title: 'Durum', text: 'Temiz, ütülü, kusursuz' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakat için yasak renk?',
        options: [
          { text: 'Lacivert', isCorrect: false, feedback: '❌ Lacivert mükemmel!' },
          { text: 'Parlak kırmızı/sarı', isCorrect: true, feedback: '✅ Çok dikkat çekici!' },
          { text: 'Siyah', isCorrect: false, feedback: '❌ Siyah klasik!' }
        ]
      }
    }
  },

  'CM-M7-U2-L3': {
    lesson_id: 'CM-M7-U2-L3',
    title: '📝 Grooming Quiz',
    type: 'quiz',
    duration: 4,
    xp: 40,
    quiz: {
      questions: [
        { q: 'İlk izlenim kaç saniyede?', options: ['30', '7', '60', '120'], correct: 1 },
        { q: 'Görünüm etkisi yüzde kaç?', options: ['10%', '30%', '55%', '90%'], correct: 2 },
        { q: 'Kadın için ideal topuk?', options: ['2cm', '5-7cm', '10cm', 'Düz'], correct: 1 },
        { q: 'Erkek için saç?', options: ['Uzun', 'Kısa düzgün', 'Renkli', 'Önemli değil'], correct: 1 },
        { q: 'Makyaj nasıl olmalı?', options: ['Yoğun', 'Doğal', 'Hiç', 'Önemli değil'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM7Interactive;
